<template>
  <button
    type="button"
    data-testid="StickyBoardButton-toggle"
    class="teacher-tool-btn"
    :class="{ selected: stickyBoardStore.open }"
    @click.stop="toggle"
  >
    <v-icon class="teacher-tool-icon">fa-light fa-note-sticky</v-icon>
    <span class="teacher-tool-label">Līmlapas</span>
  </button>
</template>

<script lang="ts">
import { useAnnotationStore } from "~/stores/annotationStore"
import { useStickyBoardStore } from "~/stores/stickyBoardStore"
import { useStudentGroupsStore } from "~/stores/studentGroupsStore"
import { useStudentWheelStore } from "~/stores/studentWheelStore"
import { useTeacherTimerStore } from "~/stores/teacherTimerStore"

export default {
  setup() {
    const annotationStore = useAnnotationStore()
    const stickyBoardStore = useStickyBoardStore()
    const studentGroupsStore = useStudentGroupsStore()
    const studentWheelStore = useStudentWheelStore()
    const timerStore = useTeacherTimerStore()
    return { annotationStore, stickyBoardStore, studentGroupsStore, studentWheelStore, timerStore }
  },

  methods: {
    toggle() {
      const opening = !this.stickyBoardStore.open
      if (opening) {
        if (this.annotationStore.annotationMode && this.annotationStore.isGlobal) {
          this.annotationStore.toggleAnnotationMode()
        }
        this.studentWheelStore.setModalOpen(false)
        this.studentGroupsStore.setModalOpen(false)
        this.timerStore.yieldToOtherTool()
      }
      this.stickyBoardStore.setOpen(opening)
    },
  },
}
</script>
